export const ARTICLE_IMPORT_STATUS_FILTERS = [
  { key: "all", label: "Të gjithë", tone: "neutral" },
  { key: "saved", label: "U ruajtën", tone: "success" },
  { key: "exists", label: "Ekzistojnë", tone: "info" },
  { key: "error", label: "Me gabime", tone: "error" },
  { key: "pending", label: "Në pritje", tone: "pending" },
  { key: "ready", label: "Pa përpunuar", tone: "neutral" },
];

export function getArticleImportStatus(row, errors) {
  if (["Uncertain", "SavedNotificationPending"].includes(row.saveStatus)) return "pending";
  if (Object.keys(errors).length) return "error";
  if (row.saveStatus === "Exists" || row.serverIssues?.some(issue => issue.Severity === "Info")) return "exists";
  if (row.saveStatus === "Saved") return "saved";
  return "ready";
}
